import ApiService from "../../../common/api.service";
import { Message } from "element-ui";

export async function GetOrderSetting({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("GET_ORDER_SETTING_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/order-setting", option);
    commit("GET_ORDER_SETTING_SUCCESS", _response);
  } catch (error) {
    commit("GET_ORDER_SETTING_ERROR", { result: error.message });
  }
}

export async function UpsertOrderSetting({ commit }, form) {
  try {
    ApiService.init("heroku");
    let payload = {
      orderSettings: []
    }
    if (form.min_pembelian != '') {
      payload.orderSettings.push({
        "name": "Minimum Total Price",
        "nameCode": "MIN_TOTAL_PRICE",
        "minValue": form.min_pembelian.split('.').join(''),
        "isActive": true
      })
    }
    if (form.min_qty != null) {
      payload.orderSettings.push({
        "name": "Minimum Item Quantity",
        "nameCode": "MIN_ITEM_QTY",
        "minValue": form.min_qty,
        "isActive": true
      })
    }
    commit("UPSERT_ORDER_SETTING_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/v1/order-setting", payload);
    commit("UPSERT_ORDER_SETTING_SUCCESS", _response);
    Message({
      message: "Upsert completed",
      type: "success"
    });
  } catch (error) {
    commit("UPSERT_ORDER_SETTING_ERROR", { result: error.message });
  }
}

